import React from 'react';
import Clickable from 'src/app/atoms/Clickable/Clickable';
import { SelectorContainer } from './TabbedFeaturesSelectorItem.styles';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Typography from 'src/app/atoms/Typography/Typography';

interface TabbedFeaturesSelectorItemProps {
  label: string;
  active: boolean;
  onClick: () => void;
}

const TabbedFeaturesSelectorItem = ({ label, active, onClick }: TabbedFeaturesSelectorItemProps): JSX.Element => (
  <Clickable onClick={onClick}>
    <SelectorContainer active={active}>
      <Stack
        padding={['spacing-3xl', 'spacing-xl', 'spacing-xl']}
        gap='spacing-xl'
        align='center'
        justify='center'
        direction='column'
      >
        <Typography
          type='paragraph'
          size='md'
          whiteSpace='nowrap'
          fontWeight='font-weight-semibold'
        >
          {label}
        </Typography>
      </Stack>
    </SelectorContainer>
  </Clickable>
);

export default TabbedFeaturesSelectorItem;
